// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cn-faq-questions__content>:not([hidden])~:not([hidden]){margin-top:calc(var(--size-base)/2)}@media(min-width:656px){.cn-faq-questions__content>:not([hidden])~:not([hidden]){margin-top:var(--size-xl)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
